// extracted by mini-css-extract-plugin
module.exports = {"ArrowLink":"ArrowLink_ArrowLink__A5_6y","Arrow":"ArrowLink_Arrow__hH7mq"};